import script from "./PedidosCardPds.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidosCardPds.vue?vue&type=script&setup=true&lang=js"

import "./PedidosCardPds.vue?vue&type=style&index=0&id=5584cea2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5584cea2"]])

export default __exports__